import React, { Component } from "react";
import Select from "react-select";

// Components
import GeneralLoader from "../../../GeneralLoader";
import ErrorWrap from "../../../utils/error-success/ErrorWrap";

const customStyles = {
	control: base => ({
		...base,
		height: 35,
		minHeight: 35
	})
};

class WorkLocationFieldset extends Component {
	constructor(props) {
		super(props);

		this.dataProps = ["address_work", "city_work", "postal_work", "province_work"];
		this.miscProps = ["errors", "locationsError", "locationsLoading", "provinces", "inProcess"];
	}

	shouldComponentUpdate(nextProps) {
		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop];
		});
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop];
		});

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults;
	}

	render() {
		const { data, errors, locationsError, locationsLoading, provinces, inProcess } = this.props;

		return (
			<div className="fieldset">
				<div className="title-label">Work Location</div>

				<div className="fieldset-indent">
					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Address:</label>

							{!!errors.address_work && ( <ErrorWrap animate={1}>{errors.address_work}</ErrorWrap> )}
							<input
								type="text"
								id="address_work"
								value={data.address_work}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
						<div className="form-field half-field">
							<label>Postal Code:</label>

							{!!errors.postal_work && ( <ErrorWrap animate={1}>{errors.postal_work}</ErrorWrap> )}
							<input
								type="text"
								id="postal_work"
								value={data.postal_work}
								maxLength="9"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={event => this.props.handleInputChange(event)}
							/>
						</div>
					</div>


					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>City:</label>

							{!!errors.city_work && ( <ErrorWrap animate={1}>{errors.city_work}</ErrorWrap> )}
							<input
								type="text"
								id="city_work"
								value={data.city_work}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
						{locationsError ? (
							<ErrorWrap>{locationsError}</ErrorWrap>
						) : locationsLoading ? (
							<GeneralLoader />
						) : (
							<div className="form-field half-field">
								<label htmlFor="province">Province:</label>

								{!!errors.province_work && ( <ErrorWrap animate={1}>{errors.province_work}</ErrorWrap> )}
								<Select
									classNamePrefix="react-select"
									placeholder={"Select one"}
									isClearable={false}
									isDisabled={inProcess}
									name={`province_work`}
									value={provinces.filter(
										({ abbreviation }) => abbreviation === data.province_work
									)}
									onChange={({ abbreviation }) => {
										this.props.updateSelectedValue(abbreviation, "province_work");
									}}
									options={provinces}
									getOptionLabel={({ name }) => name}
									getOptionValue={({ abbreviation }) => abbreviation}
									styles={customStyles}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default WorkLocationFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/reviewers/form-components/WorkLocationFieldset.js